<template>
    <div class="contact__map">
        <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item">
                <a class="nav-link active" id="first-tab" data-toggle="tab" href="#first" role="tab" aria-controls="first" aria-selected="true">New Jersey (HQ)</a>
            </li>
        </ul>
        <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" id="first" role="tabpanel" aria-labelledby="first-tab">
                <img src="/img/demo/map-1.jpg" alt="">
            </div>
            <div class="tab-pane fade" id="second" role="tabpanel" aria-labelledby="second-tab">
                <img src="/img/demo/map-2.jpg" alt="">
            </div>
            <div class="tab-pane fade" id="third" role="tabpanel" aria-labelledby="third-tab">
                <img src="/img/demo/map-1.jpg" alt="">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LocationsMap'
}

</script>



<style scoped>
</style>
